import { Component, Input, OnInit } from '@angular/core';
import { EventsService, UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-fundraiser-sipbanner',
  templateUrl: './fundraiser-sipbanner.component.html',
  styleUrls: ['./fundraiser-sipbanner.component.scss']
})
export class FundraiserSipbannerComponent implements OnInit {

  @Input() config = {
    hideEndText: false,
    hideDock: false,
    info_3: 'ended',
    queryParams: { utm_term: 'ended', utm_content: '' }
  };
  subsCount;

  constructor(
    private utilService: UtilService,
    private events: EventsService,
    public vars: VariablesService
  ) { }

  ngOnInit() {
    this.vars.getSubsCount();
    this.vars.subsCount.subscribe((res: any) => {
      this.subsCount = res;
    });
  }

  eventTracking(eventName) {
    this.events.sendSystemEvent({
      eventName: eventName,
      info_3: this.config.info_3
    }).subscribe(_ => _);
    this.utilService.scrollToTop();
    this.utilService.redirectWithUTM('new/sip', this.config.queryParams);
  }

}
